import React, { useMemo } from "react";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

ChartJS.register(ArcElement, Tooltip, Legend);

export default function DonutChart({
  values = [], // [{ label, colour, value }]
  cutout = "65%",
  showLegend = true,
  legendPosition = "bottom",
}) {
  const data = useMemo(() => {
    const normalized = (Array.isArray(values) ? values : []).map((d, i) => ({
      label: (d?.label ?? `Item ${i + 1}`).toString(),
      colour: (d?.colour ?? "#999").toString(),
      value: Number(d?.value ?? 0) || 0,
    }));

    return {
      labels: normalized.map((d) => d.label),
      datasets: [
        {
          data: normalized.map((d) => d.value),
          backgroundColor: normalized.map((d) => d.colour),
          borderWidth: 0,
          hoverOffset: 8,
          borderRadius: 6,
          spacing: 2,
        },
      ],
    };
  }, [values]);

//   debugger;
  const options = useMemo(
    () => ({
      responsive: true,
      maintainAspectRatio: false,
      animation: false,
      cutout,
      plugins: {
        legend: {
          display: true
        },
        tooltip: {
          callbacks: {
            label: (ctx) => {
              const v = ctx.parsed ?? 0;
              const total = (ctx.dataset.data || []).reduce((a, b) => a + b, 0) || 1;
              const pct = ((v / total) * 100).toFixed(1);
              return `${ctx.label}: ${v} (${pct}%)`;
            },
          },
        },
      },
    }),
    [cutout, showLegend, legendPosition]
  );

  // No wrapping div — just the chart component
  return <Doughnut data={data} options={options} />;
}
